import { fromJS } from 'immutable';
export var SET_FILTER_Items = 'traffic-live/SET_FILTER_Items';
export var SET_INFORMATION_AREA = 'traffic-live/SET_INFORMATION_AREA';
export var SET_FAVORITE_CAMERAS = 'traffic-live/SET_FAVORITE_CAMERAS'; // export const SET_TERMINAL_LIST = 'traffic-live/SET_TERMINAL_LIST'

export var SET_ZONES = 'traffic-live/SET_ZONES';
export var SET_TERMINAL_GATE_LIST = 'traffic-live/SET_TERMINAL_GATE_LIST';
export var SET_MAP_MARKER_LIST = 'traffic-live/SET_MAP_MARKER_LIST';
export var SET_DIALOG_INFO = 'traffic-live/SET_DIALOG_INFO';
export var CLEAR_DIALOG_INFO = 'traffic-live/CLEAR_DIALOG_INFO'; // export const SET_DIALOG_MODE = 'traffic-live/SET_DIALOG_MODE'
// export const SET_DIALOG_DATA = 'traffic-live/SET_DIALOG_DATA'

export var SET_TVWALL_CAMERAS = 'traffic-live/SET_TVWALL_CAMERAS';
export var SET_MAP_BOUNDS = 'traffic-live/SET_MAP_BOUNDS';
export var RESET = 'traffic-live/RESET';
export var setFilterItems = function setFilterItems(data) {
  return {
    type: SET_FILTER_Items,
    data: data
  };
};
export var setInformationArea = function setInformationArea(data) {
  return {
    type: SET_INFORMATION_AREA,
    data: data
  };
};
export var setFavoriteCameras = function setFavoriteCameras(data) {
  return {
    type: SET_FAVORITE_CAMERAS,
    data: data
  };
};
export var setZones = function setZones(data) {
  return {
    type: SET_ZONES,
    data: data
  };
};
export var setMapMarkerList = function setMapMarkerList(data) {
  return {
    type: SET_MAP_MARKER_LIST,
    data: data
  };
};
export var setDialogInfo = function setDialogInfo(data) {
  return {
    type: SET_DIALOG_INFO,
    data: data
  };
};
export var clearDialogInfo = function clearDialogInfo() {
  return {
    type: CLEAR_DIALOG_INFO
  };
}; // export const setDialogMode = data => ({
//     type: SET_DIALOG_MODE,
//     data: data
// })
// export const setDialogData = data => ({
//     type: SET_DIALOG_DATA,
//     data: data
// })

export var setTvWallCameras = function setTvWallCameras(data) {
  return {
    type: SET_TVWALL_CAMERAS,
    data: data
  };
};
export var setMapBounds = function setMapBounds(data) {
  return {
    type: SET_MAP_BOUNDS,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initDailog = {
  // dialogType: camera, roads-event, live-traffic, terminal-station, gate-station, tvwall, forecastPassingTime
  mode: '',
  data: {}
};
var initialState = fromJS({
  // filter default select all
  filterItems: ['camera', 'roads-event', 'live-traffic', 'terminal-station', 'gate-station'],
  informationArea: {},
  favoriteCameras: [],
  zones: [],
  mapMarkerList: [],
  dialogInfo: initDailog,
  // dialogType: camera, roads-event, live-traffic, terminal-station, gate-station, tvwall, forecastPassingTime
  // dialogMode: '',
  // dialogData: {},
  // tvWallCameras limit 4
  tvWallCameras: [],
  mapBounds: {}
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_FILTER_Items:
      return state.set('filterItems', action.data);

    case SET_INFORMATION_AREA:
      return state.set('informationArea', action.data);

    case SET_FAVORITE_CAMERAS:
      return state.set('favoriteCameras', action.data);

    case SET_ZONES:
      return state.set('zones', action.data);

    case SET_MAP_MARKER_LIST:
      return state.set('mapMarkerList', action.data);

    case SET_DIALOG_INFO:
      return state.set('dialogInfo', action.data);

    case CLEAR_DIALOG_INFO:
      return state.set('dialogInfo', initDailog);
    // case SET_DIALOG_MODE:
    //     return state.set('dialogMode', action.data)
    // case SET_DIALOG_DATA:
    //     return state.set('dialogData', action.data)

    case SET_TVWALL_CAMERAS:
      return state.set('tvWallCameras', action.data);

    case SET_MAP_BOUNDS:
      return state.set('mapBounds', action.data);

    case RESET:
      return initialState;

    default:
      return state;
  }
}